import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import PageHero from "@/components/PageHero";

export default function Authors() {
  const { settings } = useSettings();
  const [authors, setAuthors] = useState([]);
  useEffect(() => { api.get("/authors?status=published").then((r) => setAuthors(r.data)); }, []);

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <PageHero image={settings.authors_hero_image} overline="Autores" title="Vozes da nossa editora." subtitle="Conheça os autores que publicam com a Marupiara." />
      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {authors.map((a) => (
            <Link to={`/autor/${a.slug}`} key={a.id} data-testid={`author-card-${a.id}`} className="group">
              <div className="aspect-[4/5] overflow-hidden bg-neutral-200 mb-4">
                <img src={a.photo_url} alt={a.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <h3 className="font-serif text-2xl text-[color:var(--marupiara-text-on-light)] group-hover:text-[color:var(--marupiara-gold-dark)] transition-colors">{a.name}</h3>
              <p className="text-sm text-[color:var(--marupiara-text-on-light-muted)] mt-2 line-clamp-3">{a.biography}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
